export enum Keys {
  Backspace = 8,
  Tab = 9,
  Enter = 13,
  Escape = 27,
  Space = 32,
  End = 35,
  Home = 36,
  ArrowLeft = 37,
  ArrowUp = 38,
  ArrowRight = 39,
  ArrowDown = 40,
  Delete = 46
}

export enum Keys_Unicode {
  Cancel = '\uE001',
  Help = '\uE002',
  Backspace = '\uE003',
  Tab = '\uE004',
  Clear = '\uE005',
  Return = '\uE006',
  Enter = '\uE007',
  Shift = '\uE008',
  Control = '\uE009',
  Alt = '\uE00A',
  Pause = '\uE00B',
  Escape = '\uE00C',
  PageUp = '\uE00E',
  PageDown = '\uE00F',
  End = '\uE010',
  Home = '\uE011',
  ArrowLeft = '\uE012',
  ArrowUp = '\uE013',
  ArrowRight = '\uE014',
  ArrowDown = '\uE015',
  Insert = '\uE016',
  Delete = '\uE017'
}
